const LGPD_ID = 1
const INFORMATION_SECURITY_ID = 2

const ALL_STATUS = null
const ACTIVE_STATUS = 'ACTIVE'
const INACTIVE_STATUS = 'INACTIVE'
const DRAFT_STATUS = 'DRAFT'

const CONTRACT_ANALYSIS = 'Análise contratual'
const DUE_DILIGENCE = 'Due Diligence'

const PRIVATE_VISIBILITY = 'private_type'
const ORGANIZATIONAL_VISIBILITY = 'organization'

const CONTRACT_FILE_TYPES = '.pdf'
const CONTRACT_FILE_MIMES_TYPES = ['application/pdf']

const DUE_DILIGENCE_FILE_TYPES = '.pdf,.doc,.docx,.xls,.xlsx'
const DUE_DILIGENCE_FILE_MIMES_TYPES = [
  'application/pdf', // .pdf
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
]

const DEFAULT_ERRO_MESSAGE =
  'O sistema de de tickets está indisponível no momento. Você pode entrar em contato através do e-mail atendimento@dponet.com.br'

const LOADING_TEXTS = [
  'Analisando o documento, por favor aguarde',
  'Extraindo informações relevantes',
  'Realizando a leitura e interpretação',
  'Processando os dados enviados',
  'Identificando partes e cláusulas',
  'Gerando sugestões automáticas',
  'Aguarde enquanto terminamos de analisar o conteúdo',
]

const TICKET_SUBJECT = [
  {
    id: 'Câmeras de segurança',
    name: 'Câmeras de segurança',
  },
  {
    id: 'Compartilhamento de dados pessoais',
    name: 'Compartilhamento de dados pessoais',
  },
  {
    id: 'Consentimento',
    name: 'Consentimento',
  },
  {
    id: 'Modelos da plataforma',
    name: 'Modelos da plataforma',
  },
  {
    id: 'Política de Privacidade/Aviso de Privacidade',
    name: 'Política de Privacidade/Aviso de Privacidade',
  },
  {
    id: 'Retirada/recebimento de documentos por terceiros',
    name: 'Retirada/recebimento de documentos por terceiros',
  },
  {
    id: 'Tratamento de dados pessoais via WhatsApp/telefone',
    name: 'Tratamento de dados pessoais via WhatsApp/telefone',
  },
  {
    id: 'Tratamentos de dados pessoais de crianças e adolescentes',
    name: 'Tratamentos de dados pessoais de crianças e adolescentes',
  },
  {
    id: 'Usabilidade da plataforma (mapeamento, emissão de relatórios)',
    name: 'Usabilidade da plataforma (mapeamento, emissão de relatórios)',
  },
]

const TECHNICAL_FAQS_MAIN_DRIVER_STEP_1 = 'technical-faqs-main-step-1'

const TECHNICAL_FAQS_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + TECHNICAL_FAQS_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Oferecemos esta base de conhecimento para entender e aplicar corretamente a LGPD (Lei Geral de Proteção de Dados). Cada card oferece insights valiosos sobre conformidade, direitos individuais e procedimentos necessários para proteger dados pessoais. Ao selecionar um card, você pode aprofundar seu conhecimento sobre as melhores práticas de privacidade de dados, garantindo assim o cumprimento das regulamentações e a proteção dos dados de seus clientes e usuários.',
    },
  },
]

const TECHNICAL_FAQS_SI_MAIN_DRIVER_STEP_1 = 'technical-faqs-si-main-step-1'

const TECHNICAL_FAQS_SI_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + TECHNICAL_FAQS_SI_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Oferecemos esta base de conhecimento para entender e explorar a Segurança da Informação. Cada card representa um aspecto crucial deste campo, desde práticas de proteção de dados até estratégias de prevenção de ataques cibernéticos.  Selecione um card, descubra novos insights e esclareça suas dúvidas, fortalecendo assim sua compreensão e práticas em Segurança da Informação.',
    },
  },
]

const TECHNICAL_FAQS_TICKETS_MAIN_DRIVER_STEP_1 =
  'technical-faqs-tickets-main-step-1'

const TECHNICAL_FAQS_TICKTES_DRIVER_STEPS_OBJECT = [
  {
    element: '#' + TECHNICAL_FAQS_TICKETS_MAIN_DRIVER_STEP_1,
    popover: {
      description:
        'Acesse facilmente todas as solicitações da Central de Privacidade. Utilize os filtros disponíveis para organizar por status e acompanhar o progresso de forma eficiente e organizada.',
    },
  },
]

const VISIBILITY_TYPE = [
  {
    id: PRIVATE_VISIBILITY,
    name: 'Privado',
  },
  {
    id: ORGANIZATIONAL_VISIBILITY,
    name: 'Organizacional',
  },
]

const technicalFaqs = {
  ACTIVE_STATUS,
  ALL_STATUS,
  DRAFT_STATUS,
  INACTIVE_STATUS,
  INFORMATION_SECURITY_ID,
  LGPD_ID,
  TICKET_SUBJECT,
  TECHNICAL_FAQS_DRIVER_STEPS_OBJECT,
  TECHNICAL_FAQS_MAIN_DRIVER_STEP_1,
  TECHNICAL_FAQS_SI_DRIVER_STEPS_OBJECT,
  TECHNICAL_FAQS_SI_MAIN_DRIVER_STEP_1,
  TECHNICAL_FAQS_TICKTES_DRIVER_STEPS_OBJECT,
  TECHNICAL_FAQS_TICKETS_MAIN_DRIVER_STEP_1,
  VISIBILITY_TYPE,
  CONTRACT_ANALYSIS,
  CONTRACT_FILE_TYPES,
  CONTRACT_FILE_MIMES_TYPES,
  DEFAULT_ERRO_MESSAGE,
  PRIVATE_VISIBILITY,
  ORGANIZATIONAL_VISIBILITY,
  LOADING_TEXTS,
  DUE_DILIGENCE,
  DUE_DILIGENCE_FILE_TYPES,
  DUE_DILIGENCE_FILE_MIMES_TYPES,
}

export default technicalFaqs
